import { SharingTipRecipientInfo } from '../../types/SharingTipRecipientInfo';
import { LARGE_DL_MEMBER_COUNT } from '../constants';

export function hasLargeDLRecipient(recipientInfo: SharingTipRecipientInfo[]): boolean {
    return recipientInfo.some(function(recipientInfo) {
        return recipientInfo.totalMemberCount > LARGE_DL_MEMBER_COUNT;
    });
}
